import React from 'react';
import { Rule } from 'src/helpers/rulesEngine';
import AddYourBankDetailsContent from './AddYourBankDetailsContent';
import { CountdownRulesEngineOptions } from 'src/components/Prompt/CountdownToRefundingFlow/countdownToRefundingEngine';

const AddYourBankDetails: Rule<JSX.Element, CountdownRulesEngineOptions> = (
  state,
  options
) => {
  if (
    options &&
    options.timeRemainingFrozen.daysRemaining > 5 &&
    state.page.status !== 'Suspended'
  ) {
    return {
      matched: true,
      result: (
        <AddYourBankDetailsContent
          pageName={options.pageName}
          suspensionDate={options.frozenDate}
        />
      ),
    };
  }

  return { matched: false };
};

export default AddYourBankDetails;
